const fillTillLength = (array: any[], newLength: number, element: any) => {
  while (array.length < newLength) {
    array.push(element);
  }
  array.length = newLength;
  return array;
};

const internationalize = (date: string) => {
  let dateObj = new Date(date);
  if (dateObj instanceof Date && !isNaN(dateObj as any)) {
    return dateObj;
  }
  return new Date(date.split("/").reverse().join("-"));
};

const getVowelsArray = (text: string, orderRelation?: any) => {
  const letters = text.split("");
  const vowels = letters.filter((char) =>
    ["a", "e", "i", "o", "u"].includes(char)
  );
  return orderRelation && typeof orderRelation === "function"
    ? vowels.sort(orderRelation)
    : vowels;
};

const getConsonantsArray = (text: string, orderRelation?: any) => {
  const letters = text.split("");
  const consonants = letters.filter(
    (char) => !["a", "e", "i", "o", "u"].includes(char)
  );
  return orderRelation && typeof orderRelation === "function"
    ? consonants.sort(orderRelation)
    : consonants;
};

const processName = (name: string) => {
  let consonants = getConsonantsArray(name);
  let vowels = getVowelsArray(name);

  let result = "";

  if (consonants.length >= 4) {
    result = consonants[0] + consonants[2] + consonants[3];
  } else {
    for (let i = 0; result.length < 3 && i < consonants.length; i++) {
      result += consonants[i];
    }
  }

  for (let i = 0; result.length < 3 && i < vowels.length; i++) {
    result += vowels[i];
  }

  while (result.length < 3) {
    result += "x";
  }

  return result;
};

const processSurname = (surname: string) => {
  let consonants = getConsonantsArray(surname);
  let vowels = getVowelsArray(surname);
  let result = "";
  for (let i = 0; result.length < 3 && i < consonants.length; i++) {
    result += consonants[i];
  }
  for (let i = 0; result.length < 3 && i < vowels.length; i++) {
    result += vowels[i];
  }

  while (result.length < 3) {
    result += "x";
  }

  return result;
};

const dateOfBirth = (dateOfBirth: string, gender: "M" | "F") => {
  const converted = internationalize(dateOfBirth);

  let day = converted.getDate();

  if (gender === "F") {
    day += 40;
  }

  const monthCodes = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "H",
    "L",
    "M",
    "P",
    "R",
    "S",
    "T",
  ];

  let yearValue = converted.getFullYear().toString().substring(2, 4);
  let monthCode: string = monthCodes[converted.getMonth()];
  let dayStr = day.toLocaleString();
  return yearValue + monthCode + dayStr;
};

const ComputeSecurityDigit = (partialFiscalCode: string) => {
  let convertMap = [
    ["A0", 0, 1],
    ["B1", 1, 0],
    ["C2", 2, 5],
    ["D3", 3, 7],
    ["E4", 4, 9],
    ["F5", 5, 13],
    ["G6", 6, 15],
    ["H7", 7, 17],
    ["I8", 8, 19],
    ["J9", 9, 21],
    ["K", 10, 2],
    ["L", 11, 4],
    ["M", 12, 18],
    ["N", 13, 20],
    ["O", 14, 11],
    ["P", 15, 3],
    ["Q", 16, 6],
    ["R", 17, 8],
    ["S", 18, 12],
    ["T", 19, 14],
    ["U", 20, 16],
    ["V", 21, 10],
    ["W", 22, 22],
    ["X", 23, 25],
    ["Y", 24, 24],
    ["Z", 25, 23],
  ];

  let resultMap = [
    [0, "A"],
    [1, "B"],
    [2, "C"],
    [3, "D"],
    [4, "E"],
    [5, "F"],
    [6, "G"],
    [7, "H"],
    [8, "I"],
    [9, "J"],
    [10, "K"],
    [11, "L"],
    [12, "M"],
    [13, "N"],
    [14, "O"],
    [15, "P"],
    [16, "Q"],
    [17, "R"],
    [18, "S"],
    [19, "T"],
    [20, "U"],
    [21, "V"],
    [22, "W"],
    [23, "X"],
    [24, "Y"],
    [25, "Z"],
  ];

  let sum = 0;

  for (let i = 0; i < partialFiscalCode.length; i++) {
    let char = partialFiscalCode[i];
    let partialMatchItem: any = convertMap.find(
      (x: any) => x[0].indexOf(char) !== -1
    );
    sum += partialMatchItem[2 - (i % 2)] as number;
  }
  return resultMap[sum % 26][1];
};

const ComputePhiscalCode = (
  name: string,
  surname: string,
  born: string,
  sex: "M" | "F",
  cmCode: string
) => {
  let dateText = dateOfBirth(born, sex);

  let cf =
    processSurname(surname.toLowerCase()) +
    processName(name.toLowerCase()) +
    dateText +
    cmCode;

  let partialCf = cf.toLocaleUpperCase();
  let securityCode = ComputeSecurityDigit(partialCf);
  return partialCf + securityCode;
};

const PhiscalCodeUtil = {
  ComputePhiscalCode,
};

export default PhiscalCodeUtil;
